// Typelizer digest 627a22ce02a9f2e468f4311be80c22b0
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /reportes/export_excel */
  exportExcel: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/reportes/export_excel', {}, options),
    method: 'get',
  }),

  /** GET /reportes */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/reportes', {}, options),
    method: 'get',
  }),
}
